import axios from 'axios';
import ActionTypes from '../../constants';

const queueExportRequest = () => ({
  type: ActionTypes.QUEUE_EXPORT_REQUEST,
});

const queueExportSuccess = () => ({
  type: ActionTypes.QUEUE_EXPORT_SUCCESS,
});

const queueExportError = () => ({
  type: ActionTypes.QUEUE_EXPORT_ERROR,
});

const queueExportAsync = details => async (dispatch, getState) => {
  dispatch(queueExportRequest());

  const state = getState();
  const socketId = state.socket.get('id');
  const data = { ...details, socketId };

  try {
    const res = await axios({
      url: '/v1/exports',
      method: 'POST',
      responseType: 'json',
      data,
    });
    dispatch(queueExportSuccess());
    dispatch({
      type: ActionTypes.NOTIFY_EXPORT_SUCCESS,
      notificationPayload:
        'Your export request has been received, download will begin shortly.',
      notificationType: 'info',
      notificationDelay: ActionTypes.NOTIFICATION_DELAY,
    });
    return Promise.resolve(res);
  } catch (rej) {
    dispatch(queueExportError());
    dispatch({
      type: ActionTypes.NOTIFY_EXPORT_ERROR,
      notificationPayload: `Error submitting export request.
        Please contact support@ordermentum.com`,
      notificationType: 'error',
      notificationDelay: ActionTypes.NOTIFICATION_DELAY,
    });
    return Promise.reject(rej);
  }
};

export {
  queueExportRequest,
  queueExportSuccess,
  queueExportError,
  queueExportAsync,
};
